import { MessageCircle, Mail, Instagram, MapPin } from 'lucide-react';
import { Reveal } from './Reveal';
import {
  waLink,
  DEFAULT_WA_MESSAGE,
  WHATSAPP_DISPLAY,
  EMAIL,
  INSTAGRAM,
  INSTAGRAM_URL,
  ADDRESS,
} from '../data/site';

const CARDS = [
  {
    id: 'whatsapp',
    icon: MessageCircle,
    label: 'WhatsApp',
    value: WHATSAPP_DISPLAY,
    href: waLink(DEFAULT_WA_MESSAGE),
  },
  {
    id: 'email',
    icon: Mail,
    label: 'E-mail',
    value: EMAIL,
    href: `mailto:${EMAIL}`,
  },
  {
    id: 'instagram',
    icon: Instagram,
    label: 'Instagram',
    value: INSTAGRAM,
    href: INSTAGRAM_URL,
  },
  {
    id: 'address',
    icon: MapPin,
    label: 'Endereço',
    value: ADDRESS,
    href: 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent('Rua de Pedestre 151, Jardim Teresópolis, Betim, MG'),
  },
];

export const Contact = () => (
  <section
    id="contato"
    data-testid="contact-section"
    className="relative py-24 sm:py-32 bg-blue-600 overflow-hidden"
  >
    <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-white/10 blur-[120px] pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-200 mb-4">
          06 — Fale comigo
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl text-white leading-none">
          Bora regularizar
          <br />
          <span className="text-blue-950">seu veículo?</span>
        </h2>
        <p className="mt-6 max-w-lg mx-auto text-blue-100 text-sm sm:text-base leading-relaxed">
          Me chama no WhatsApp, descreve a situação do veículo e eu te retorno
          com o passo a passo e o orçamento.
        </p>
        <a
          data-testid="contact-whatsapp-button"
          href={waLink(DEFAULT_WA_MESSAGE)}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-9 inline-flex items-center gap-2.5 bg-white hover:bg-blue-50 text-blue-600 font-bold rounded-full px-9 py-4 text-base transition-all duration-300 hover:shadow-[0_18px_45px_rgba(15,23,42,0.35)]"
        >
          <MessageCircle size={20} />
          Chamar o Davy no WhatsApp
        </a>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((card, i) => (
          <Reveal key={card.id} delay={i * 0.08}>
            <a
              data-testid={`contact-card-${card.id}`}
              href={card.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-4 rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm p-6 h-full transition-colors duration-300 hover:bg-white/20"
            >
              <card.icon size={22} className="text-white" />
              <div>
                <p className="text-[10px] font-mono uppercase tracking-[0.22em] text-blue-200">
                  {card.label}
                </p>
                <p className="mt-1.5 text-sm font-semibold break-words text-white">
                  {card.value}
                </p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
